<template>
  <div class="accordion-container">
    <!-- slot for collapse items -->
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, provide, ref } from "vue";

interface Props {
  startCollapsed?: boolean;
}

export interface AccordionProvide {
  count: number;
  active: number | null;
  start_collapsed: boolean;
}

const props = withDefaults(defineProps<Props>(), {});

// Sets up object to track accordions
const Accordion = ref<AccordionProvide>({
  count: 0,
  active: props.startCollapsed ? null : 0,
  start_collapsed: props.startCollapsed,
});

// provides accordion-tracker that is injected in child collapse items
provide("Accordion-tracker", Accordion.value);

onUnmounted(() => {
  Accordion.value.count = 0;
  Accordion.value.active = 0;
});
</script>

<style lang="scss" scoped></style>
